import type { DocPageContent } from '../docs-content'

const page = {
  order: 13,
  slug: 'effects-color',
  title: '特效与色彩',
  description: '特效、预设、调色、示波器、LUT、限定器和调整层。',
  category: '创意工具',
  sections: [
    {
      title: '特效工作流程',
      items: [
        '从"特效"标签页或属性面板搜索并添加特效。',
        '使用颜色、模糊、变形、风格化和抠像等分类。',
        '启用、禁用、重新排序、移除和重置特效。',
        '在可用时保存和应用预设。',
      ],
    },
    {
      title: '色彩工作区',
      items: [
        '在色彩工作区中选择一个片段进行调色。',
        '使用色轮、曲线、色阶、曝光、对比度、饱和度和鲜艳度控件。',
        '在可见时使用波形图、矢量示波器和直方图示波器。',
        '使用"之前"、"之后"和"分割"对比进行调色审查。',
      ],
    },
    {
      title: '高级色彩工具',
      items: [
        '导入 .cube LUT 文件并调整强度。',
        '使用"强力窗口"和"二次限定器"控件进行局部校正。',
        '使用"色度键"进行绿幕或蓝幕抠除。',
        '使用调整层将特效或调色应用于下方的片段。',
      ],
    },
  ],
} satisfies DocPageContent

export default page